var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQwikIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_4975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_238_4975)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.295 7.00002C16.136 7.00002 18.331 8.59102 18.331 11.488C18.3703 12.442 18.1734 13.391 17.7579 14.2507C17.3423 15.1104 16.721 15.8541 15.949 16.416L16.896 17.382L15.131 19L13.61 17.353C13.2076 17.4275 12.7993 17.4656 12.39 17.467C11.3922 17.5441 10.3959 17.3008 9.54604 16.7723C8.69619 16.2439 8.0372 15.458 7.665 14.529L3.465 13.429H7.442V13.42H8.849L7.474 12.183C7.49267 12.0237 7.51633 11.867 7.545 11.713L2 10.2H9.657L8.606 9.23402C9.15413 8.51617 9.86529 7.93915 10.6807 7.55067C11.496 7.1622 12.3922 6.97344 13.295 7.00002ZM13.209 9.27202C11.415 9.25802 10.483 11.019 10.483 12.908C10.4481 13.3259 10.5303 13.7452 10.7203 14.1189C10.9104 14.4927 11.2008 14.8061 11.559 15.024L13.267 13.632L14.214 14.612C14.5821 14.203 14.8655 13.725 15.0478 13.2058C15.2301 12.6866 15.3076 12.1364 15.276 11.587C15.3141 11.295 15.2889 10.9982 15.202 10.7168C15.115 10.4354 14.9685 10.1761 14.7724 9.95639C14.5763 9.73672 14.3351 9.56188 14.0653 9.44378C13.7955 9.32569 13.5035 9.2671 13.209 9.27202Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_4975",
    x1: 24,
    y1: 12,
    x2: 0,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2C00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_4975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwikIcon);
export default __webpack_public_path__ + "static/media/Qwik-icon.e28f014e978a6b69771e4cbb228a79e1.svg";
export { ForwardRef as ReactComponent };